import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION7: PdfComponent = {
  type: 'section',
  id: 's7',
  title: '7. Information Undertakings',
  content: [
    {
      type: 'bulletList',
      id: 's7bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Each of Kanda and the Subscriber undertake and warrant that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Kanda and the Subscriber shall keep records of each Credit Agreement and any other document evidencing compliance with their respective obligations under this Agreement for the period required by the relevant regulatory authorities from the date of expiry of the Credit Agreement, or for such longer period as Kanda may reasonably require. These records shall be stored securely.',
              },
              {
                copy: "The Subscriber shall ensure that Kanda, or any lender to whom a Credit Agreement relates (or their appointed representatives), is entitled to inspect, or appoint representatives to inspect, on giving at least 5 Business Days' notice to the Subscriber (except where such notice is not required due to suspected breach of this Agreement or the relevant Credit Agreement), the Subscriber's premises, facilities, and all records, equipment, documents and electronic data:",
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'relating to the Processing of Personal Data by the Subscriber; and',
                    },
                    {
                      copy: 'in order to enable Kanda and/or the relevant lender to monitor the activities of the Subscriber to demonstrate compliance with all Applicable Laws and the terms and conditions of this Agreement.',
                    },
                  ],
                },
              },
              {
                copy: 'The Subscriber shall at all times co-operate fully with any such inspection.',
              },
            ],
          },
        },
        {
          copy: 'Subscriber shall supply to Kanda:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'as soon as the same become available, its audited consolidated and non-consolidated financial statements for that financial year; and',
              },
              {
                copy: 'as soon as the same become available, its consolidated and non-consolidated financial statements for that financial half year.',
              },
            ],
          },
        },
        {
          copy: 'Each set of financial statements delivered by the Subscriber pursuant to clause 7.2 shall be certified by a director of the Subscriber as fairly representing its (or, as the case may be, its consolidated) financial condition as at the end of and for the period in relation to which those financial statements were drawn up.',
        },
        {
          copy: "Kanda shall have the right, on 5 Business Days' notice to the Subscriber, to request to perform an audit of the Subscriber where Kanda has reason to believe (including based on information from any lender) that the Subscriber may not be in compliance with the terms of this Agreement or with Applicable Laws. The Subscriber shall, at its own cost, permit Kanda to access any premises, systems, files, records, databases, employees, contractors, consultants, staff, suppliers, agents or other assets, property or resources owned by or within the control of the Subscriber, as may reasonably be required by Kanda to complete such audit to Kanda's reasonable satisfaction. The Subscriber shall also provide whatever reasonable assistance Kanda requires in connection with the audit, again at the Subscriber's own cost.",
        },
        {
          copy: 'Subscriber shall procure that each set of financial statements delivered pursuant to clause 7.2 is prepared using GAAP, or when not applicable, in accordance with relevant accounting standards.',
        },
        {
          copy: 'On request by Kanda, the Subscriber shall supply to Kanda, or directly to a relevant lender or regulator (as directed):',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'all documents dispatched by the Subscriber to its creditors generally at the same time as they are dispatched;',
              },
              {
                copy: "promptly upon becoming aware of them, the details of any litigation, arbitration or administrative proceedings which are current, threatened or pending against any member of the Subscriber's Group and which might, if adversely determined, have a Material Adverse Effect;",
              },
              {
                copy: "promptly, such further information regarding the financial condition, business and operations of any member of the Subscriber's Group as Kanda, a relevant lender, or any regulator with jurisdiction over the Applicable Laws may reasonably request (including, without limitation, management accounts and answers to data protection questionnaires); and",
              },
              {
                copy: "promptly upon becoming aware, the details of any changes to information previously provided regarding the financial condition, business and operations of any member of the Subscriber's Group provided to Kanda, any lender, or any regulator with jurisdiction over the Applicable Laws (including, without limitation, changes to management accounts and changes to answers to data protection questionnaires).",
              },
            ],
          },
        },
        {
          copy: 'Subscriber shall immediately notify Kanda:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'of any default under, or breach of, or misrepresentation made in relation to, this Agreement (and the steps, if any, being taken to remedy it) promptly upon becoming aware of its occurrence;',
              },
              {
                copy: 'should it become aware of any event or circumstances relating to itself or any member of its Group that has resulted in, or might result in, a Material Adverse Effect; and',
              },
              {
                copy: 'if it becomes aware of any event or circumstance triggering an Exception.',
              },
            ],
          },
        },
        {
          copy: 'Kanda reserves the right to conduct reasonable identification, fitness and propriety checks upon those connected with the Subscriber, including but not limited to its directors, shareholders, owners, or other senior managers and influencers. This may include obtaining information from credit reference agencies. The Subscriber shall procure that all such persons provide their irrevocable consent, while they remain connected to the Subscriber, for Kanda to conduct such checks from time to time.',
        },
        {
          copy: 'Kanda may record all telephone conversations with Customers, Subscribers, and other third parties pursuant to the arrangements contemplated by this Agreement. Such recordings may be used for legal protection, training, quality control, monitoring, and compliance purposes. The Subscriber acknowledges and agrees that Kanda may record such telephone discussions and that any such recordings may be submitted in evidence to any court or in any proceedings.',
        },
      ],
      prefix: '7',
    },
  ],
};
